import { forwardRef, SyntheticEvent } from 'react'
import VendorDatePicker from 'react-datepicker'
import { shift } from '@floating-ui/react-dom'
import { Input } from './Input'
import { createEvent } from 'utilities/createEvent'
import { XIcon } from '@heroicons/react/solid'

interface Props {
  value: Date
  onChange(date: Date | null, event?: SyntheticEvent): void
  onMonthChange?: (date: Date) => void
  onCalendarClose?: () => void
  valueComponent?: any
  hideLabel?: boolean
  disabled?: boolean
  clearButton?: boolean
  inline?: boolean
  monthsShown?: number
  minDate?: Date
  excludeDates?: Date[]
  dayClassName?: (date: Date) => string
}

export type { Props as DatePickerProps }

export const DatePicker = forwardRef<unknown, Props>(
  ({ value, onChange, hideLabel = false, clearButton, valueComponent = null, ...props }, ref) => {
    const CustomInput: any = forwardRef(({ value, onClick }: any, ref) => (
      <div className="relative">
        <Input label="" name="" onFocus={onClick} value={value} onChange={() => null} {...props} />
        {clearButton && value && (
          <button
            type="button"
            onClick={(event) => onChange(null, event)}
            className="absolute right-0 top-0 p-1 rounded-full m-1 text-gray-400 hover:text-violet"
          >
            <XIcon className="h-5 w-5" />
          </button>
        )}
      </div>
    ))

    return (
      <VendorDatePicker
        selected={value}
        onChange={onChange}
        dateFormat="dd/MM/yyyy"
        showPopperArrow={false}
        popperModifiers={[
          shift({
            padding: 10,
          }),
        ]}
        customInput={valueComponent ? valueComponent : <CustomInput />}
        // @ts-expect-error Uses legacy ref.
        ref={ref}
        {...props}
      />
    )
  }
)

export const FormikDatePicker = forwardRef(
  ({ onChange: parentOnChange, ...props }: any, ref: any) => {
    const handleChange = (value) => {
      parentOnChange(createEvent({ value: value || '', name: props.name }))
    }

    return <DatePicker name={props.name} onChange={handleChange} ref={ref} {...props} />
  }
)
